import { Injectable } from '@angular/core';
import { RolesButtonsService } from '../../services/roles-buttons.service';
import { MenuItem } from './sidebar.component';

@Injectable()
export class SidebarService {
  constructor(private rolesButtonsService: RolesButtonsService) { }

  getMenuItens(): MenuItem[] {
    return [
      {
        label: 'Dashboard',
        icon: 'fas fa-chart-line',
        route: '/dashboard',
        hasAccess: this.rolesButtonsService.isAccessible('dashboard'),
      },
      {
        label: 'Importação',
        icon: 'fas fa-plane-arrival',
        route: '/imports',
        hasAccess: this.rolesButtonsService.isAccessible('imports'),
        children: [
          {
            label: '1 - Order Service ',
            route: '/imports/order-service',
            hasAccess: this.rolesButtonsService.isAccessible('imports.order-service'),
          },
          {
            label: '2 - Houses (HAWB)',
            route: '/imports/houses',
            hasAccess: this.rolesButtonsService.isAccessible('imports.houses'),
          },
          {
            label: '3 - Consolidators (BAG)',
            route: '/imports/consolidators',
            hasAccess: this.rolesButtonsService.isAccessible('imports.consolidators'),
          },
          {
            label: '4 - Masters (MAWB)',
            route: '/imports/masters',
            hasAccess: this.rolesButtonsService.isAccessible('imports.masters'),
          },
          {
            label: '4.1 - Master Post Office(MAWBP)',
            route: '/imports/master-post-office',
            hasAccess: this.rolesButtonsService.isAccessible('imports.master-post-office'),
          },
          {
            label: '5 - Siscomex',
            route: '/imports/siscomex',
            hasAccess: this.rolesButtonsService.isAccessible('imports.siscomex'),
          },
          {
            label: '6 - Checkpoints em Lote',
            route: '/process/checkpoints-lote',
            hasAccess: this.rolesButtonsService.isAccessible('imports.siscomex'),
          },
          {
            label: '7 - Checkpoints Process',
            route: '/process/checkpoints-process',
            hasAccess: this.rolesButtonsService.isAccessible('imports.siscomex'),
          },
          {
            label: '8 - Armazen',
            route: '/manga/manga',
            hasAccess: this.rolesButtonsService.isAccessible('imports.siscomex'),
          },
        ],
      },
      {
        label: 'Warehouse',
        icon: 'fas fa-warehouse',
        route: '/warehouse',
        hasAccess: this.rolesButtonsService.isAccessible('warehouse'),
        children: [
          {
            label: 'Pre alert',
            route: '/mile-express-wms/pre-alert',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.pre-alert'),
          },
          {
            label: 'Inbounds',
            route: '/mile-express-wms/inbounds',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.inbounds'),
          },
          {
            label: 'Outbounds',
            route: '/mile-express-wms/outbounds',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.outbounds'),
          },
          {
            label: 'Products',
            route: '/mile-express-wms/products',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.products'),
          },
          {
            label: 'Stock',
            route: '/mile-express-wms/stock',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.stock'),
          },
          {
            label: 'Reports',
            route: '/mile-express-wms/reports',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.reports'),
          },
          {
            label: 'File upload',
            route: '/mile-express-wms/file-upload',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.file-upload'),
          },
          {
            label: 'Setting',
            route: '/mile-express-wms/settings',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.settings'),
          },
          {
            label: 'Client Transfer',
            route: '/mile-express-wms/client-transfers',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.client-transfers'),
          },
          {
            label: 'Inventory',
            route: '/mile-express-wms/inventory-list',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.inventory-list'),
          },
          {
            label: 'Airports',
            route: '/mile-express-wms/airports',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.airports'),
          },
          {
            label: 'Carriers',
            route: '/mile-express-wms/carriers',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.carriers'),
          },
          {
            label: 'Packages',
            route: '/mile-express-wms/packages',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.packages'),
          },
          {
            label: 'Locations',
            route: '/mile-express-wms/locations',
            hasAccess: this.rolesButtonsService.isAccessible('warehouse.locations'),
          },
        ],
      },
      {
        label: 'Exportação',
        icon: 'fas fa-plane-departure',
        route: '/export',
        hasAccess: this.rolesButtonsService.isAccessible('export'),
        children: [
          {
            label: 'Devolution',
            route: '/export/devolution',
            hasAccess: this.rolesButtonsService.isAccessible('export.devolution'),
          },
          {
            label: 'Devolution Siscomex',
            route: '/export/devolution-siscomex',
            hasAccess: this.rolesButtonsService.isAccessible('export.devolution-siscomex'),
          },
        ],
      },
      {
        label: 'Correios',
        icon: 'fas fa-mail-bulk',
        route: '/post-office',
        hasAccess: this.rolesButtonsService.isAccessible('post-office'),
        children: [
          {
            label: '1 - Packages',
            route: '/post-office/packages',
            hasAccess: this.rolesButtonsService.isAccessible('post-office.packages'),
          },
          {
            label: '2 - Unitizations',
            route: '/post-office/unitizations',
            hasAccess: this.rolesButtonsService.isAccessible('post-office.unitizations'),
          },
          {
            label: '3 - Invoices',
            route: '/post-office/invoices',
            hasAccess: this.rolesButtonsService.isAccessible('post-office.invoices'),
          },
        ],
      },
      {
        label: 'Last Mile',
        icon: 'fas fa-truck',
        route: '/last-mile',
        hasAccess: this.rolesButtonsService.isAccessible('lastmile'),
        children: [
          {
            label: '1 - Deliveries',
            route: '/last-mile/deliveries',
            hasAccess: this.rolesButtonsService.isAccessible('lastmile.deliveries'),
          },
          {
            label: '2 - Providers',
            route: 'last-mile/shipping-company',
            hasAccess: this.rolesButtonsService.isAccessible('lastmile.provider'),
          },
        ],
      },
      {
        label: 'Operation',
        icon: 'fas fa-file-alt',
        route: '/romanians',
        hasAccess: this.rolesButtonsService.isAccessible('romanians'),
        children: [
          {
            label: 'Romaneios',
            route: '/romanians',
            hasAccess: this.rolesButtonsService.isAccessible('romanians'),
          },
        ],
      },
      {
        label: 'Consignees',
        icon: 'fas fa-user-friends',
        route: '/importers',
        hasAccess: this.rolesButtonsService.isAccessible('importers'),
      },

      {
        label: 'Shippers',
        icon: 'fas fa-store-alt',
        route: '/shippers',
        hasAccess: this.rolesButtonsService.isAccessible('shippers'),
      },

      {
        label: 'Customers ',
        icon: 'fas fa-building',
        route: '/companies',
        hasAccess: this.rolesButtonsService.isAccessible('companies'),
        children: [
          {
            label: 'Empresas',
            route: '/companies',
            hasAccess: this.rolesButtonsService.isAccessible('companies.companies'),
          },
        ],
      },

      {
        label: 'Financeiro',
        icon: 'fas fa-hand-holding-usd',
        route: '/financial',
        hasAccess: this.rolesButtonsService.isAccessible('financial'),
        children: [
          {
            label: 'Dashboard',
            route: '/financial/dashboard',
            hasAccess: this.rolesButtonsService.isAccessible('financial'),
          },
          {
            label: 'Faturas',
            route: '/financial/invoices',
            hasAccess: this.rolesButtonsService.isAccessible('financial.invoices'),
          },
          {
            label: 'Clientes',
            route: '/financial/clients',
            hasAccess: this.rolesButtonsService.isAccessible('financial.clients'),
          },
          {
            label: 'Empresas',
            route: '/financial/companies',
            hasAccess: this.rolesButtonsService.isAccessible('financial.companies'),
          },
          {
            label: 'Tabelas de Tarifa',
            route: '/financial/tariff-tables',
            hasAccess: this.rolesButtonsService.isAccessible('financial.tariff-tables'),
          },
          {
            label: 'Notas de Débito',
            route: '/financial/debit-note',
            hasAccess: this.rolesButtonsService.isAccessible('financial.debit-note'),
          },
          {
            label: 'Multas',
            route: '/financial/fines',
            hasAccess: this.rolesButtonsService.isAccessible('financial.fines'),
          },
          {
            label: 'Impostos a Pagar',
            route: '/financial/taxpayable',
            hasAccess: this.rolesButtonsService.isAccessible('financial.taxpayable'),
          },
          {
            label: 'File GNRE',
            route: '/financial/file-gnre',
            hasAccess: this.rolesButtonsService.isAccessible('financial'),
          },
          {
            label: 'Conciliação CNAB',
            route: '/financial/concilia-cnab',
            hasAccess: this.rolesButtonsService.isAccessible('financial'),
          },
          {
            label: 'Skypostal',
            route: '/financial/skypostal',
            hasAccess: this.rolesButtonsService.isAccessible('financial.skypostal'),
          },
        ],
      },
      {
        label: 'Voos',
        icon: 'fas fa-plane fa-rotate-270',
        route: '/airports',
        hasAccess: this.rolesButtonsService.isAccessible('airports'),
        children: [
          {
            label: 'Aeroportos',
            route: '/airports',
            hasAccess: this.rolesButtonsService.isAccessible('airports.airports'),
          },
        ],
      },
      {
        label: 'Retornos do banco',
        icon: 'fas fa-university',
        route: '/bank-files',
        hasAccess: this.rolesButtonsService.isAccessible('bank-files'),
      },
      // {  // movido para o menu Operation
      //   label: 'Romaneios',
      //   icon: 'fas fa-file-alt',
      //   route: '/romanians',
      //   hasAccess: this.rolesButtonsService.isAccessible('romanians'),
      // },
      {
        label: 'Messages',
        icon: 'fas fa-envelope',
        route: '/messages',
        hasAccess: this.rolesButtonsService.isAccessible('messages'),
        children: [
          {
            label: 'Message Log',
            icon: 'fas fa-envelope-open-text',
            route: '/process/message-log',
            hasAccess: this.rolesButtonsService.isAccessible('messages.message-log'),
          },
          {
            label: 'Notificações',
            icon: 'fas fa-bell',
            route: '/process/notifications',
            hasAccess: this.rolesButtonsService.isAccessible('messages.notifications'),
          },
          // {
          //   label: 'Checkpoints Lote',
          //   icon: 'fas fa-list-check',
          //   route: '/process/checkpoints-lote',
          //   hasAccess: true, // TEMPORÁRIO: Permissão desabilitada para testes
          //   // hasAccess: this.rolesButtonsService.isAccessible('messages.checkpoints-lote'),
          // },
        ],
      },
      {
        label: 'Process',
        icon: 'fas fa-terminal',
        route: '/process',
        hasAccess: this.rolesButtonsService.isAccessible('process'),
        children: [
          {
            label: 'RPA',
            icon: 'fas fa-robot',
            route: '/process/rpa',
            hasAccess: this.rolesButtonsService.isAccessible('process.rpa'),
          },
        ],
      },
      {
        label: 'Configurações',
        icon: 'fas fa-cogs',
        route: '/settings',
        hasAccess: this.rolesButtonsService.isAccessible('settings'),
        children: [
          {
            icon: 'fas fa-users',
            label: '1 - Utilizadores',
            route: '/settings/users',
            hasAccess: this.rolesButtonsService.isAccessible('settings.users'),
          },
          {
            icon: 'fas fa-sitemap',
            label: '2 - Hierarquias',
            route: '/settings/roles',
            hasAccess: this.rolesButtonsService.isAccessible('settings.roles'),
          },
          {
            icon: 'far fa-check-circle',
            label: '3 - Checkpoints',
            route: '/settings/checkpoints',
            hasAccess: this.rolesButtonsService.isAccessible('settings.checkpoints'),
          },
          {
            icon: 'fas fa-shopping-bag',
            label: '4 - Icms',
            route: '/settings/icms',
            hasAccess: this.rolesButtonsService.isAccessible('settings.icms'),
          },
          {
            icon: 'fas fa-map-marker-alt',
            label: '5 - Faixas de CEP',
            route: '/settings/zipcode-ranges',
            hasAccess: this.rolesButtonsService.isAccessible('settings.zipcode-ranges'),
          },
          {
            icon: 'fas fa-bell',
            label: '6 - Tipo de Notificação',
            route: '/configuration/notification-type',
            hasAccess: this.rolesButtonsService.isAccessible('settings.notification-type'),
          },
          {
            icon: 'fas fa-sync-alt',
            label: '7 - Sync',
            route: '/configuration/sync',
            hasAccess: true,
          },
        ],
      },
    ] as MenuItem[];
  }
}
